/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../index';

/**
 * @example
 *     {
 *         compositionType: "EMBED",
 *         credentialIds: ["credential_ids", "credential_ids"],
 *         holder: "holder"
 *     }
 */
export interface PresentationExportRequest {
    compositionType: Truvity.PresentationExportRequestCompositionType;
    credentialIds: string[];
    /** Just regular URI according to [RFC 3986](https://www.rfc-editor.org/rfc/rfc3986). */
    holder: string;
}
